import React, { Component } from 'react';
import { StatusInfo } from 'grommet-icons';
import PropTypes from 'prop-types';
import { Box, Text, TextInput, Button } from 'grommet';
import { SendPasswordOTPCtrl } from '../Controllers/Account/SendPasswordOTPCtrl';
import ModalErrorTimeout from './ModalErrorTimeout';
import { loader } from '../Utils/Utility';
import {ERRORMESSAGE} from '../Constants.js';


class Error extends React.Component {

    render() {
        return (
            <Box className="errorEditPass">
                {this.props.testo ? <Text className='error'>{this.props.testo}</Text> : <Text className='errorhide2'></Text>}
            </Box>
        );
    }
}


export default class NuovaPassword extends Component {
    static propTypes = {
        match: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    }
    constructor(props) {
        super(props); 
        this.state = {
            status: '',
            showTimeoutModal: false,
            loading: false

        }
        this.sendOTP = this.sendOTP.bind(this);

    }


    saveAndContinue = (e) => {
        //e.preventDefault()
        this.props.nextStep()
    }

    sendOTP(e) {
        e.preventDefault()
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        self.setState({loading: true});
        SendPasswordOTPCtrl(function (data) {
            self.setState({
                data: data === undefined ? [] : data,
                loading: false
            }, function(){ 
                    if( data === true){
                        this.saveAndContinue();
                    }
            });
            
        }, function (error) {
            self.setState({
                status: error,
                loading: false
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })  
                } else if (this.state.status === 401)
                    {this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    // pathname: '/login'
                    // })
                } 
            })

        }, this.state, token, ids);
    }

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }


    render() {

        return (

            <Box className='contentbox'>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box direction="column" align='center'>
                    <Box direction='row' >
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Modifica password</h1>
                        <Text className='titlehome' style={{ marginBottom: '5px' }}></Text> 
                    </Box>
                    <form style={{width:'275px'}}>
                    <Box style={{ height: '350px', width: '325px' }}>
                        <Box className='formimp' direction='column' margin='small' >
                            <div style={{ height:'70px', textAlign: 'left' }}>
                                <Text className='label'>VECCHIA PASSWORD</Text>
                                <div  style={{ display:'inline-flex' }}>
                                    <TextInput id='oldPassword' type='password' size='medium' className={`inputFormdisp ${this.props.msgPassOld ? 'errorBoxInput' : '' }`} value={this.props.values.oldPassword} onChange={this.props.setOldPassword} />
                                    <div className="tooltip"><StatusInfo className="iconTooltip" aria-label="Informazioni sulla password attuale"/><span className="tooltiptext">{ERRORMESSAGE.msgold}</span></div>
                                </div>
                            </div>
                            <Error testo={this.props.msgPassOld} />
                        </Box>
                        <Box className='formimp' direction='column' margin='small' >
                            <div style={{ height:'70px', textAlign: 'left' }}>
                                <Text className='label'>NUOVA PASSWORD</Text>
                                <div  style={{ display:'inline-flex' }}>
                                    <TextInput id='password' type='password' size='medium' className={`inputFormdisp ${this.props.msgPassNew ? 'errorBoxInput' : '' }`} value={this.props.values.newPassword} onChange={this.props.setNewPassword} />
                                    <div className="tooltip"><StatusInfo className="iconTooltip" aria-label="Requisiti nuova password"/>
                                        <span className="tooltiptext">
                                            La password deve essere compresa tra 8 e 20 caratteri e deve soddisfare almeno 3 di queste regole:
                                            <br/>- Lettere maiuscole[A-Z]
                                            <br/>- Lettere minuscole[a-z]
                                            <br/>- Almeno un numero[0-9]
                                            <br/>- Almeno un carattere speciale (~!@#$^*()-_=+[]&#10100;&#10101;|;:,.&lt;&gt;/?'"`)
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <Error testo={this.props.msgPassNew}/>
                        </Box>
                        <Box className='formimp' direction='column' margin='small' >
                            <div style={{ height:'70px', textAlign: 'left' }}>
                                <Text className='label'>CONFERMA NUOVA PASSWORD</Text>
                                <div  style={{ display:'inline-flex' }}>
                                    <TextInput id='confirmpwd' type='password' onChange={this.props.setConfirmPassword} className={`inputFormdisp ${this.props.msgPassConf ? 'errorBoxInput' : '' }`} value={this.props.values.confirmNewPassword} confirmpwd={this.props.values.confirmNewPassword} placeholder='' />
                                    <div className="tooltip"><StatusInfo className="iconTooltip" aria-label="Conferma nuova password"/><span className="tooltiptext">{ERRORMESSAGE.msgpasswordconf}</span></div>
                                </div>
                            </div>
                            <Error testo={this.props.msgPassConf}/>
                        </Box>
                    </Box>
                    <Box justify='center' direction='row'>
                        <Button className='btnform btnimp' type='submit' disabled={this.props.values.disableButtonNewPwd} onClick={this.sendOTP}>AVANTI</Button>
                    </Box>
                    </form>
                    {this.state.loading ? loader : ''}
                </Box>
            </Box >
        )
    }
}
